/**
 * Machine-readable `code` on `SocketEvent.Error` payloads from the server.
 * Keep in sync with `addata/src/sockets/socketErrorCodes.ts`.
 */
export const SEAT_HELD_BY_OTHER_PLAYER = "SEAT_HELD_BY_OTHER_PLAYER" as const;

export function isSeatHeldByOtherPlayerError(data: { message?: string; code?: string }): boolean {
  if (data.code === SEAT_HELD_BY_OTHER_PLAYER) return true;
  return /seat belongs to another player/i.test(data.message ?? "");
}
